import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import ResponsiveLayout from "./components/ResponsiveLayout";

// Import all components
import Signup from "./components/Signup";
import Login from "./components/Login";
import Profile from "./components/Profile";
import Dashboard from "./components/Dashboard";
import VerifyEmail from "./components/VerifyEmail";
import ForgotPassword from "./components/ForgotPassword";
import ResetPassword from "./components/ResetPassword";
import AdminDashboard from "./components/AdminDashboard";
import DashboardPage from "./components/dashboard/index";
import AnalysisPage from "./components/analysis/index";
import AlertsPage from "./components/alerts/index";
import AppointmentsPage from "./components/appointments/index";
import ScrollToTop from "./config/scrollToTop";
import AIAnalysis1 from "./components/AI analysis 1/index";
import AIAnalysis2 from "./components/AI analysis 2/index";
import AIAnalysis3 from "./components/AI analysis 3/index";
import PatientInfo from "./components/patient info/index";
import InsightsPage from "./components/insights/index";
import GlucoseLevel from "./components/glucose level/index";
import GlucoseTrends from "./components/glucose trend/index";
import TimeInRange from "./components/time in range/index";
import InsulinUsage from "./components/insulin usage/index";
import EventsFrequency from "./components/events/index";
import BillingReport from "./components/billing report/index";
import GroomingPage from "./components/grooming/index";
import Splash from "./components/splash_main";
import Splash1 from "./components/splash1";
import Splash2 from "./components/splash2";
import Splash3 from "./components/splash3";
import SetupPage from "./components/setUpPage";
import VerificationPage from "./components/verificationPage";
import NewPasswordpage from "./components/newPassword";
import ConnectPage from "./components/connectPage";
import MapPage from "./components/mapPage";
import ReviewPage from "./components/reviewPage";


function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Splash />} />  // Default route to Login
        <Route path="/splash1" element={<Splash1/>} />
        <Route path="/splash2" element={<Splash2/>} />
        <Route path="/splash3" element={<Splash3/>} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/login" element={<Login />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/verify/:token" element={<VerifyEmail />} />
        <Route path="/profile/:id" element={<Profile />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password/:token" element={<ResetPassword />} />
        <Route path="/admin-dashboard" element={<AdminDashboard />} />

        <Route path="/setupPage" element={<SetupPage/>} />
        <Route path="/verificationpage" element={<VerificationPage/>} />
        <Route path="/password" element={<NewPasswordpage/>} />
        <Route path="/connect" element={<ConnectPage/>} />
        <Route path="/mapyourdata" element={<MapPage/>} />
        <Route path="/review" element={<ReviewPage/>} />

        <Route path="/dashboard-page" element={<DashboardPage />} />
        <Route path="/analysis" element={<AnalysisPage />} />
        <Route path="/alerts" element={<AlertsPage />} />
        <Route path="/appointments" element={<AppointmentsPage />} />
        <Route path="/Aianalysis1" element={<AIAnalysis1 />} />
        <Route path="/Aianalysis2" element={<AIAnalysis2 />} />
        <Route path="/Aianalysis3" element={<AIAnalysis3 />} />
        <Route path="/patientinfo" element={<PatientInfo />} />
        <Route path="/insights" element={<InsightsPage />} />
        <Route path="/glucoselevel" element={<GlucoseLevel />} />
        <Route path="/insulinusage" element={<InsulinUsage />} />
        <Route path="/glucosetrends" element={<GlucoseTrends />} />
        <Route path="/timeinrange" element={<TimeInRange />} />
        <Route path="/events" element={<EventsFrequency />} />
        <Route path="/billingreport" element={<BillingReport />} />
        <Route path="/grooming" element={<GroomingPage />} />

      </Routes>
    </Router>
  );
}


export default App;
